import platformAPI from "../services/platformApi";

export function platformSupportPath(threadKey) {
  return `/admin/support/${encodeURIComponent(threadKey)}`;
}

export async function startClubSupportChat(tenantId, { userId } = {}) {
  const data = await platformAPI.startSupportThread({
    tenant_id: tenantId,
    ...(userId ? { user_id: userId } : {}),
  });
  return {
    path: platformSupportPath(data.thread_key),
    threadKey: data.thread_key,
    meta: data.meta || null,
  };
}
